<div class="custom-workspace">
  <div class="right-bar">
    <div class="top">
    </div>
    <div class="divider">
      <mat-divider></mat-divider>
    </div>
    <div class="bottom">
      <div class="components-list">
        <div *ngIf="listCustomWorkspaceDto?.length > 0" class="animation-items">
          <div *ngFor="let item of listCustomWorkspaceDto" class="component-book">
            <div class="quote-name">{{ item.title | uppercase}}</div>
            <div *ngIf="item.type !== 'worksheet'" class="company-name">{{ item.assetSymbol }}</div>
            <div *ngIf="item.type === 'worksheet'" class="company-name">{{ getItemsWorksheet(item) }}</div>
            <div class="delete-button">
              <mat-icon (click)="addComponentSelectorInput(item, 1)" class="closeIcon" svgIcon="close"></mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="save-button">
        <button *ngIf="!isRequesting" mat-raised-button [disabled]="listCustomWorkspaceDto?.length == 0 || isRequesting"
          (click)="saveWorkspace()" class="md add" color="primary02">
          adicionar ferramentas
          <div class="add-circle">
            +
          </div>
        </button>
        <app-spinner-loading *ngIf="isRequesting"></app-spinner-loading>
      </div>
    </div>
  </div>
  <div class="workspace-area">
    <button class="close-button" (click)="showConfirmClose()">
      <mat-icon class="closeIcon" svgIcon="close"></mat-icon>
      <span class="button-text2">Sair</span>
    </button>
    <button class="goback-button" (click)="goBack()">
      <mat-icon svgIcon="goback"></mat-icon>
      <span class="button-text2">Voltar</span>
    </button>
    <div class="workspace-cards">
      <div class="" *ngFor="let item of cardTitles">
        <app-component-selector-input (addSelectInput)="addComponentSelectorInput($event)" [cardTitle]="item"
          *ngIf="item.id === 'book' || item.id === 'volume-at-price' || item.id === 'times-trades' || item.id === 'asset-summary' || item.id === 'quote-chart' ||  item.id === 'billet-root'"
          [cardTitle]="item">
        </app-component-selector-input>
        <app-component-selector-select (addMultiple)="addComponentSelectorInput($event)" [cardTitle]="item"
          *ngIf="item.id === 'worksheet' || (item.id === 'high-low-day' || item.id === 'order-wks' || item.id === 'news-wks' || item.id === 'position-day' || item.id === 'position-balance-wks')">
        </app-component-selector-select>
      </div>
    </div>
  </div>
</div>
